module.exports = __webpack_public_path__ + "static/img/di-zhu-jin.1602623.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/di-zhu-jin.jpg
// module id = hDDI
// module chunks = 1